import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const BREADCRUMB_TRUNCATED_MENU_CLASS_NAME = 'Breadcrumb';
export const BREADCRUMB_TRUNCATED_MENU_CLASS_SLOTS = [
	'root',
	'popover',
] as const;

export type BreadcrumbTruncatedMenuClassSlot =
	(typeof BREADCRUMB_TRUNCATED_MENU_CLASS_SLOTS)[number];

export interface BreadcrumbTruncatedMenuClasses {
	root: string;
	popover: string;
}

export type BreadcrumbTruncatedMenuClassKey =
	keyof BreadcrumbTruncatedMenuClasses;

export const getBreadcrumbTruncatedMenuUtilityClass = (slot: string) =>
	generateUtilityClass(BREADCRUMB_TRUNCATED_MENU_CLASS_NAME, slot);

export const breadcrumbTruncatedMenuClasses: BreadcrumbTruncatedMenuClasses =
	generateUtilityClasses(BREADCRUMB_TRUNCATED_MENU_CLASS_NAME, [
		'root',
		'popover',
	]);

export default breadcrumbTruncatedMenuClasses;
